import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { SidenavData, ToolbarData } from 'sgh-navbar';
import { SystemAdminMenu, UserMenu } from '../../constants/menu';
// import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-main-layout',
  standalone: false,
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  menu: any[] = [];
  activeComponent: string | null = null;
  auth = inject(AuthService);
  private permissionService = inject(PermissionService);
  private cdr = inject(ChangeDetectorRef);
  // private router = inject(Router);

  isCollapseSidebar = false;

  toggleSidebar() {
    this.isCollapseSidebar = !this.isCollapseSidebar;
  }

  ngOnInit(): void {
    this.updateMenuByComponent();
  }

  private updateMenuByComponent() {
    this.permissionService.fetchPermission().subscribe({
      next: (_) => {
        if (this.auth.isAdmin()) {
          this.menu = SystemAdminMenu;
        }

        //
        else {
          this.menu = UserMenu.filter((m) => {
            const permissionData: any =
              this.permissionService.getScreenPermissionsData();
            // Claims is currently a product-level route while backend role
            // permissions are being introduced for the new module.
            return m.key === 'claims' || permissionData?.[m.key];
          });
        }
        this.sidenavConfig.navData = this.menu;
        // this.router.navigate([this.menu[0].routeLink]);
        this.cdr.detectChanges();
      },
    });
  }

  sidebarCollapse = true;
  isNavExpanded = false;

  sidenavConfig: SidenavData = {
    imgSm: 'assets/icons/trigma-logo-1.svg',
    imgLg: 'assets/icons/trigma-logo-1.svg',
    navData: [],
    bgColor: '#ffffff',
  };
  toolbarConfig: ToolbarData = {
    bgColor: '#ffffff',
    img: 'assets/icons/trigma-logo-1.svg',
    themeOptions: [
      {
        name: 'Dark Theme',
        value: 'dark-theme',
        checked: true,
      },
    ],
    profileEnable: true,
    profileContent: `
    <div class="profile-info">
      <p>${this.auth.getProperty('first_name')}</p>
    </div>
  `,
    clientList: [],
  };

  onToggleSidebar(expanded: boolean): void {
    this.isNavExpanded = expanded;
  }
}
